<template>
	<div class="Home">
		<div class="Top">
			<div class="Top-Index1">
				<div>
					<div class="Top-Content">
						<div class="Top-Index-Left">
							<div class="Top-Left-Name">公司数量</div>
							<div class="Top-Left-Value">{{companyCount}}</div>
							<div class="Top-Left-describe">当前公司数量</div>
						</div>
						<div class="Top-Index-right flex-center">
							<div class="Top-Index1 flex-center">
								<i class="el-icon-office-building"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="Top-Index2">
				<div>
					<div class="Top-Content">
						<div class="Top-Index-Left">
							<div class="Top-Left-Name">人员数量</div>
							<div class="Top-Left-Value">{{employeesCount}}</div>
							<div class="Top-Left-describe">当前人员数量</div>
						</div>
						<div class="Top-Index-right flex-center">
							<div class="Top-Index2 flex-center">
								<i class="el-icon-user"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="Top-Index3">
				<div>
					<div class="Top-Content">
						<div class="Top-Index-Left">
							<div class="Top-Left-Name">设备总数量</div>
							<div class="Top-Left-Value">{{controllersCount}}</div>
							<div class="Top-Left-describe">当设备总数量</div>
						</div>
						<div class="Top-Index-right flex-center">
							<div class="Top-Index3 flex-center">
								<i class="el-icon-mobile-phone"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="Top-Index4">
				<div>
					<div class="Top-Content">
						<div class="Top-Index-Left">
							<div class="Top-Left-Name">在线设备数量</div>
							<div class="Top-Left-Value">{{onlineControllersCount}}</div>
							<div class="Top-Left-describe">云端设备数量</div>
						</div>
						<div class="Top-Index-right flex-center">
							<div class="Top-Index4 flex-center">
								<i class="el-icon-connection"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="Statistics">
			<div class="Statistics-Left">
				<div class="Statistics-Title">
					<div>今日验证</div>
					<div class="Card-hint">
						<div>
							<i class="el-icon-remove" style="color: #409EFF;"></i>&nbsp;二维码
						</div>
						<div>
							<i class="el-icon-remove" style="color: #67C23A;"></i>&nbsp;IC卡
						</div>
						<div>
							<i class="el-icon-remove" style="color: #E6A23C;"></i>&nbsp;密码
						</div>
						<div>
							<i class="el-icon-remove" style="color: #E94B73;"></i>&nbsp;人脸
						</div>
						<div>
							<i class="el-icon-remove" style="color: #00C9A7;"></i>&nbsp;按钮
						</div>
					</div>
				</div>
				<div id="homeCardRecord" class="homeCardRecord"></div>
			</div>
			<div class="Statistics-Right">
				<div class="Statistics-Title">
					<div>验证比例</div>
				</div>
				<div class="progress">
					<el-table :data="brushcardArr"> 
						<el-table-column prop="type" align="center" label="类型">
							<template slot-scope="scope">
								<div v-if="scope.row.CardType == '1'" class="card_type" style="color: #409EFF;">二维码</div>
								<div v-else-if="scope.row.CardType == '2'" class="card_type" style="color: #67C23A;">IC卡</div>
								<div v-else-if="scope.row.CardType == '3'" class="card_type" style="color: #E6A23C;">密码</div>
								<div v-else-if="scope.row.CardType == '4'" class="card_type" style="color: #E94B73;">人脸</div>
								<div v-else-if="scope.row.CardType == '5'" class="card_type" style="color: #00C9A7;">按钮</div>
								<div v-else-if="scope.row.CardType == '0'" class="card_type">所有</div>
							</template>
						</el-table-column>
      					<el-table-column prop="Number" align="center" label="次数"></el-table-column>
      					<el-table-column prop="Ratio" align="center" label="比例">
							<template slot-scope="scope">
								{{scope.row.Ratio}}%
							</template>
						</el-table-column>
    				</el-table>
				</div>
			</div>
		</div>
		<div class="controller_statistics">
			<div class="controller_statistics_left flex-center">
				<div id="homecontrollerType" class="homecontrollerType"></div>
			</div>
			<div class="controller_statistics_right">
				<div class="Apply-Title flex-items-center">
					公司设备数详情
					<div>{{companyDetails.length}}</div>
				</div>
				<div class="Apply-Table">
					<el-table :data="companyDetails"> 
						<el-table-column prop="companyName" align="center" width="250px" label="公司名称"></el-table-column>
						<el-table-column prop="employeesCount" align="center" label="公司人数">
							<template slot-scope="scope">
								{{scope.row.employeesCount}} 人
							</template>
						</el-table-column>
      					<el-table-column prop="controllersCount" align="center" label="设备总数">
							<template slot-scope="scope">
								{{scope.row.controllersCount}} 台
							</template>
						</el-table-column>
      					<el-table-column prop="onlineControllersCount" align="center" label="在线设备数">
							<template slot-scope="scope">
								{{scope.row.onlineControllersCount}} 台
							</template>
						</el-table-column>
      					<el-table-column prop="brushCarCount" align="center" label="今日验证数">
							<template slot-scope="scope">
								{{scope.row.brushCarCount}} 次
							</template>
						</el-table-column>
    				</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BsStatistics',
		data (){
			return {
				//云端公司数
				companyCount:0,
				//云端公司人数
				employeesCount:0,
				//云端公司设备数
				controllersCount:0,
				//在线公司设备数
				onlineControllersCount:0,
				// 刷卡记录统计
				brushcardArr:[],
				//公司详情
				companyDetails: []
		    }
	    },
		//完成html渲染后执行
		mounted(){
			//查询数量
			this.queryBsCount();
			//刷卡流量统计
			this.queryBrushCardRecord();
			//查询验证占比
			this.queryBrushCardProportion();
			//查询设备占比
			this.queryControllerTypeCount();
			//查询公司详情
			this.queryCompanyStatistics();
		},
		methods: {
			//查询数量
			async queryBsCount(){
				try 
				{
					var {data: res} = await this.$http.post('queryBsBasicsCount');
					if (this.ReturnFiltration(res.code)) {
						this.companyCount=res.result.companyCount;
						this.employeesCount=res.result.employeesCount;
						this.controllersCount=res.result.controllersCount;
						this.onlineControllersCount=res.result.onlineControllersCount;
					}
				} 
				catch (e) 
				{
					this.$notify.error({title: '错误',message:e});
				}
			},
			//刷卡流量统计
			async queryBrushCardRecord(){
				try {
					var {data: res} = await this.$http.post('queryBrushCardRecord');
					if (this.ReturnFiltration(res.code)) 
					{
						var Record = res.result.cardRecord;
						let myCard = this.$echarts.init(document.getElementById('homeCardRecord'),'light');
						var option = {
							color: ['#409EFF','#67C23A','#E6A23C','#E94B73','#00C9A7'],
							tooltip: {
							    trigger: 'axis'
							},
							grid: {
								left: '3%',
								top: '5%',
								right: '3%',
								bottom: '10%',
								containLabel: true
							},
							xAxis: {
						        type: 'category',
						        boundaryGap: false,
						        data: this.TimeQuantum()
						    },
						    yAxis: {
						        type: 'value',
								splitNumber: 3,
								splitLine: {
								    show: true,
								    lineStyle:{
								        type:'dashed'
								    }
								}
						    },
						    series: [
								{
									name:'二维码',
									smooth: true,
									data:this.CardCount(Record,"1"),
									type: 'line',
									areaStyle: {},
									symbolSize: 10,
									symbol: 'circle',
									lineStyle: {
										color: "#409EFF",
										width: 3,
									},
									areaStyle:{
										color:"rgba(246,248,253, 0.5)"
									}
								},
								{
									name:'IC卡',
									smooth: true,
									data:this.CardCount(Record,"2"),
									type: 'line',
									areaStyle: {},
									symbolSize: 10,
									symbol: 'circle',
									lineStyle: {
										color: "#67C23A",
										width: 3,
									},
									areaStyle:{
										color:"rgba(246,248,253, 0.5)"
									}
								},
								{
									name:'密码卡号',
									smooth: true,
									data:this.CardCount(Record,"3"),
									type: 'line',
									areaStyle: {},
									symbolSize: 10,
									symbol: 'circle',
									lineStyle: {
										color: "#E6A23C",
										width: 3,
									},
									areaStyle:{
										color:"rgba(246,248,253, 0.5)"
									}
								},
								{
									name:'人脸',
									smooth: true,
									data:this.CardCount(Record,"4"),
									type: 'line',
									areaStyle: {},
									symbolSize: 10,
									symbol: 'circle',
									lineStyle: {
										color: "#E94B73",
										width: 3,
									},
									areaStyle:{
										color:"rgba(246,248,253, 0.5)"
									}
								},
								{
									name:'按钮',
									smooth: true,
									data:this.CardCount(Record,"5"),
									type: 'line',
									areaStyle: {},
									symbolSize: 10,
									symbol: 'circle',
									lineStyle: {
										color: "#00C9A7",
										width: 3,
									},
									areaStyle:{
										color:"rgba(246,248,253, 0.5)"
									}
								}
							]
						};
						myCard.setOption(option);
						//设置自动适应页面大小
						window.onresize = function(){
						    myCard.resize();
						}
					}
				} catch (e) {
					this.$notify.error({title: '错误',message:e});
				}
			},
			//时间段
			TimeQuantum(){
				var Time = [];
				for(var i=0;i<24;i++){
					var StartHH = i<10?'0'+i+":00":i.toString()+":00";
					var endHH = "";
					if(i==23)
					{
						endHH = "23:00";
					}
					else
					{
						endHH = (i+1)<10?'0'+(i+1)+":00":(i+1).toString()+":00";
					}
					Time[i] = StartHH+" - "+endHH;
				}
				return Time;
			},
			//查询验证占比
			async queryBrushCardProportion(){
				try 
				{
					var {data: res} = await this.$http.post('queryBrushCardProportion');
					if(res.code == "100001"){
						let list = res.result.List;
						//获取刷卡总数
						let sum = list.reduce(function (accumulator, currentValue) { return accumulator + currentValue.Number;}, 0);
						for(let i=0;i<list.length;i++){
							list[i].Ratio = sum == 0 ? 0 : ((list[i].Number / sum) * 100).toFixed(2);
						}
						list[list.length] = {CardType:0,Number:sum,Ratio:100};
						this.brushcardArr = list;
					}
				} 
				catch (e) 
				{
					this.$notify.error({title: '错误',message:e});
				}
			},
			//查询公司详情
			async queryCompanyStatistics(){
				try 
				{
					var {data: res} = await this.$http.post('queryCompanyStatistics');
					if(res.code == "100001"){
						let list = res.result.array;
						this.companyDetails = list;
					}
				} 
				catch (e) 
				{
					this.$notify.error({title: '错误',message:e});
				}
			},
			//刷卡次数
			CardCount(Record,Type){
				var Data = {};
				for(var i=0;i<Record.length;i++)
				{
					if(Record[i].cardType==Type)
					{
						Data = Record[i];
						break;
					}
				}
				var ReturnData = [];
				var HH = new Date().getHours()
				for(var i=0;i<24;i++)
				{
					if(i<=HH)
					{
						if(Data["time"+i]!=undefined)
						{
							ReturnData[ReturnData.length] = Data["time"+i];
						}
						else
						{
							ReturnData[ReturnData.length] = 0;
						}
					}
				}
				return ReturnData;
			},
			//查询设备占比
			async queryControllerTypeCount(){
				try
				{
					var {data: res} = await this.$http.post('queryControllerTypeCount');
					if (this.ReturnFiltration(res.code)) {
						var controllerCount = res.result.controllerTypeCount;
						let myChart = this.$echarts.init(document.getElementById('homecontrollerType'),'light');
						var option = {
							color: ['#409EFF','#23CCB3','#FAAE42','#FF6E40','#D63384','#6610F2'],
							title: {
						        text: '设备类型占比',
								subtext: '设备类型数量占比',
						        left: 'center',
								top:'4%',
								textStyle:{
									fontSize: 15,
								}
						    },
						    tooltip: {
						        trigger: 'item'
						    },
						    legend: {
						        top: '80%',
						        left: 'center'
						    },
						    series: [
						        {
						            name: '设备数量',
						            type: 'pie',
						            radius: ['25%', '45%'],
      								center: ['50%', '45%'],
									avoidLabelOverlap: true,
									itemStyle: {
										borderRadius: 5,
										borderColor: '#fff',
										borderWidth: 2
									},
									// label: {
									// 	show: false,
									// 	position: 'center'
									// },
									// labelLine: {
									// 	show: false
									// },
						            data:this.controllerType(controllerCount)
						        }
						    ]
						};
						myChart.setOption(option);
						//设置自动适应页面大小
						window.onresize = function(){
						    myChart.resize();
						}
					}
				} catch (e) {
					this.$notify.error({title: '错误',message:e});
				}
				
			},
			//设备类型占比
			controllerType(controller){
				var Data = [];
				for(var i=0;i<controller.length;i++)
				{
					Data[i] = {name:controller[i].controllersubtype+"("+controller[i].count+"台)",value:controller[i].count}
				}
				return Data;
			},
			//记录类型
			RecordType(recordtype,Type){
				if(recordtype==1) 
				{
					//权限更新
					return Type=="ICON"?"el-icon-refresh":"Timeline-Index-Icon flex-center TimelineType1";
				}
				else if(recordtype==2)
				{
					//软件激活
					return Type=="ICON"?"el-icon-key":"Timeline-Index-Icon flex-center TimelineType2";
				}
				else if(recordtype==3)
				{
					//使用申请
					return Type=="ICON"?"el-icon-s-order":"Timeline-Index-Icon flex-center TimelineType3";
				}
			},
			//跳转到申请界面
			skip(){
				this.$router.push('/BsApply');//跳转
			},
			// 返回过滤
			ReturnFiltration(code) {
				if (code == "100001") {
					//成功
					return true;
				} else if (code == "100002") {
					//Session过期
					this.Message('身份已过期，请重新登录', "warning");
					return false;
				} else if (code == "100003") {
					//校验失败
					this.Message('校验失败，请重新登录', "error");
					return false;
				} else if (code == "100004") {
					//格式不正确
					this.Message('请求参数不正确', "error");
					return false;
				} else if (code == "100005") {
					//操作失败
					this.Message('操作失败', "error");
					return false;
				}
			},
			//提醒消息
			Message(message, type) {
				this.$message({showClose: true,message: message,type: type,offset: "14"});
			}
	  	}
	}
</script>

<style scoped>
	/* 头部数据 */
	.Top{
		width: 100%;
		height: 120px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.Top>div{
		width: 24%;
		height: 100%; 
		display: flex;
		border-radius: 12px;
		justify-content: flex-end;
	}
	
	.Top>div>div{
		/* width: 98.5%; */
		width: 100%;
		height: 100%;
		border-radius: 10px;
		background-color: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.Top-Content{
		width: 90%;
		height: 90%;
		display: flex;
		justify-content: space-between;
	}
	
	.Top-Index-Left{
		height: 100%;
	}
	
	.Top-Left-Name{
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #636363;
		height: 30%;
	}
	
	.Top-Left-Value{
		display: flex;
		align-items: center;
		font-size: 40px;
		font-weight: 700;
		height: 40%;
	}
	
	.Top-Left-describe{
		display: flex;
		align-items: center;
		font-size: 13px;
		color: #959595;
		height: 30%;
	}
	
	.Top-Index-right{
		height: 100%;
	}
	
	.Top-Index-right>div{
		width: 65px;
		height: 65px;
		border-radius: 50%;
	}
	
	.Top-Index-right>div>i{
		color: #FFFFFF;
		font-size: 30px;
	}
	
	.Top-Index1{
		background-color: #23CCB3;
		color: #23CCB3;
	}
	
	.Top-Index2{
		background-color: #409EFF;
		color: #409EFF;
	}
	
	.Top-Index3{
		background-color: #8354C8;
		color: #8354C8;
	}
	
	.Top-Index4{
		background-color: #E94B73;
		color: #E94B73;
	}
	
	.Statistics{
		margin-top: 20px;
		height: 420px;
		display: flex;
		justify-content: space-between;
	}
	
	.Statistics-Left{
		width: 74.6%;
		height: 100%;
		background-color: #FFFFFF;
		border-radius: 10px;
	}
	.Statistics-Right{
		width: 23.8%;
		height: 100%;
		background-color: #FFFFFF;
		border-radius: 10px;
	}
	
	.Statistics-Title{
		height: 14%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding:0px 25px;
		font-size: 15px;
		color:#666666;
		font-weight: 700;
		border-radius: 10px 10px 0px 0px;
	}
	
	.Card-hint{
		display: flex;
		align-items: center;
	}
	
	.Card-hint>div{
		display: flex;
		align-items: center;
		font-size: 14px;
		margin: 0px 10px;
		color: #909399;
		font-weight: 500;
	}
	
	.Card-hint i{
		font-size: 20px;
		margin-top: 1px;
	}
	
	.homeCardRecord{
		width: 100%;
		height: 86%;
	}
	
	.homecontrollerType{
		width: 100%;
		height: 100%;
	}
	.progress{
		padding: 0px 25px;
	}

	.card_type{
		/* margin: px 0px; */
	}
	
	/* 设备统计 */
	.controller_statistics{
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	
	.controller_statistics_left{
		width: 500px;
		height: 550px;
		border-radius: 10px;
		overflow:hidden;
		background-color: #FFFFFF;
	}
	
	/* 申请列表 */
	.controller_statistics_right{
		flex-grow: 1;
		width: 0px;
		margin-left: 20px;
		border-radius: 10px;
		background-color: #FFFFFF;
	}
	
	.Apply-Title{
		height: 65px;
		padding-left: 25px;
		font-size: 15px;
		color: #58666E;
		font-weight: 700;
	}
	
	.Apply-Title>div{
		padding: 1px 12px;
		margin-left: 10px;
		border-radius: 3px;
		font-size: 14px;
		color: #FFFFFF;
		background-color: #409EFF;
	}
	
	.Apply-Table{
		height: 400px;
		margin: 10px auto;
		width: 95%;
		overflow-y: auto;
	}
	
	.Apply-Table-Icon{
		font-size: 17px;
		/* color: #409EFF; */
	}
</style>
